import { isEqual, cloneDeep } from "lodash";
import { getStoreApiUrl } from "../helpers/api";
import { HOME_DELIVERY } from "../constants/OrderTypes";
const isItemsMatch = (cartItem, menuItem) => {
  cartItem = cloneDeep(cartItem);
  menuItem = cloneDeep(menuItem);
  return (
    (cartItem.menuId === menuItem.menuId || cartItem.id === menuItem.id) &&
    (!menuItem.variantId || menuItem.variantId === cartItem.variantId) &&
    (!menuItem.choiceIds ||
      isEqual(menuItem.choiceIds.sort(), cartItem.choiceIds.sort())) &&
    (!menuItem.addonIds ||
      isEqual(menuItem.addonIds.sort(), cartItem.addonIds.sort()))
  );
};
let cartSyncTimout = null;
let isPendingCartSyncTimeout = false;
export const state = () => ({
  token: "",
  restaurantsList: [],
  restaurantsListByAvailability: [],
  restaurantDetails: {},
  addresses: [],
  cart: {},
  cartLoading: false,
  cartSyncing: false,
  infoLoading: false,
  surveyResponse: [
    {
      keys: 1,
      title: "key 1 title",
      feedback: [
        { id: 1, label: "A" },
        { id: 2, label: "B" }
      ]
    },
    {
      keys: 2,
      title: "What went wrong?",
      feedback: [
        { id: 3, label: "Food was not that good" },
        { id: 4, label: "Too long for delivery" },
        { id: 5, label: " Packing quality is not good" }
      ]
    },
    {
      keys: 3,
      title: "key 3 title",
      feedback: [
        { id: 6, label: "A" },
        { id: 7, label: "B" }
      ]
    },
    {
      keys: 4,
      title: "key 4 title",
      feedback: [
        { id: 8, label: "A" },
        { id: 9, label: "B" }
      ]
    },
    {
      keys: 5,
      title: "key 5 title",
      feedback: [
        { id: 10, label: "A" },
        { id: 11, label: "B" },
        { id: 12, label: "C" }
      ]
    }
  ]
});

export const mutations = {
  SET_TOKEN: function (state, token) {
    state.token = token;
  },
  SET_RESTAURANTS_LIST: function (state, restaurantsList) {
    state.restaurantsList = restaurantsList;
  },
  SET_RESTAURANTS_LIST_BY_AVAILABILITY: function (state, restaurantsList) {
    state.restaurantsListByAvailability = restaurantsList;
  },
  SET_RESTAURANT_DETAILS: function (state, restaurantDetails) {
    state.restaurantDetails = restaurantDetails;
  },
  SET_ADDRESSES: function (state, addresses) {
    state.addresses = addresses;
  },
  SET_CART_LOADING: function (state, cartLoading) {
    state.cartLoading = cartLoading;
  },
  SET_INFO_LOADING: function (state, infoLoading) {
    state.infoLoading = infoLoading;
  },
  SET_CART: function (state, cart) {
    state.cart = cart;
  },
  SET_CART_ITEMS: function (state, items = []) {
    state.cart.items = items;
  },
  SET_CART_SYNCING: function (state, cartSyncing) {
    state.cartSyncing = cartSyncing;
  }
};
export const actions = {
  loginWithToken({ dispatch, commit, state }, payload) {
    return new Promise((resolve, reject) => {
      this.$axios
        .post(getStoreApiUrl("login"), payload)
        .then(async function ({ data }) {
          const { token, order_type } = data?.data;
          $nuxt.$ls.set("store-token", token);
          $nuxt.$axios.defaults.headers["Authorization"] = `Bearer ${token}`;
          dispatch("getRestaurantsList");
          dispatch("getInfo");
          commit("SET_CART", { ...state.cart, order_type });
          resolve(token);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getRestaurantsList({ dispatch, commit }, payload) {
    return new Promise((resolve, reject) => {
      this.$axios
        .get(getStoreApiUrl("business/business_list"))
        .then(async function (res) {
          const data = res.data?.map(({ data }) => data);
          commit("SET_RESTAURANTS_LIST", data);
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getNearestRestaurant({ dispatch, commit }, { latitude, longitude }) {
    return new Promise((resolve, reject) => {
      const maxRetries = 6;

      const makeRequest = (retryCount = 0) => {
        this.$axios
          .get(getStoreApiUrl("business/nearest_restaurant"), {
            params: {
              lat: latitude,
              lng: longitude
            }
          })
          .then(async function ({ data: { data } } = {}) {
            if (data && data.restaurant_id) {
              $nuxt.$ls.set("selected-restaurant", data.restaurant_id);
              commit("SET_RESTAURANT_DETAILS", data);
              await dispatch("fetchCart");
              resolve(data);
            } else {
              console.warn("No restaurants found within the range.");
              reject(new Error("No restaurants found within the range."));
            }
          })
          .catch((err) => {
            if (err.message === "Porter timeout" && retryCount < maxRetries) {
              console.log(
                `Retrying getNearestRestaurant (attempt ${
                  retryCount + 1
                }/${maxRetries})`
              );
              setTimeout(() => makeRequest(retryCount + 1), 0);
            } else {
              console.error(
                "Max retries reached or another error occurred:",
                err
              );
              if (retryCount >= maxRetries) {
                this.$router.push(`/order/index`);
              }
              reject(err);
            }
          });
      };

      makeRequest();
    });
  },
  getAvailableRestaurants({ dispatch, commit }, { latitude, longitude }) {
    return new Promise((resolve, reject) => {
      const maxRetries = 6;

      const makeRequest = (retryCount = 0) => {
        this.$axios
          .get(getStoreApiUrl("business/available_restaurants"), {
            params: {
              lat: latitude,
              lng: longitude
            }
          })
          .then(async function ({ data }) {
            commit("SET_RESTAURANTS_LIST_BY_AVAILABILITY", data);
            resolve(data);
          })
          .catch((err) => {
            if (err.message === "Porter timeout" && retryCount < maxRetries) {
              console.log(
                `Retrying getAvailableRestaurants (attempt ${
                  retryCount + 1
                }/${maxRetries})`
              );
              setTimeout(() => makeRequest(retryCount + 1), 0);
            } else {
              reject(err);
            }
          });
      };

      makeRequest();
    });
  },
  getInfo({ dispatch, state, commit }) {
    const token = $nuxt.$ls.get("store-token");
    if (!token) {
      dispatch("loginWithToken");
      return;
    }
    const restaurantId = $nuxt.$ls.get("selected-restaurant");
    if (!restaurantId) return;
    // commit("SET_TOKEN", token);
    commit("SET_INFO_LOADING", true);
    return new Promise((resolve, reject) => {
      this.$axios
        .get(getStoreApiUrl(`info/${restaurantId}`))
        .then(function ({ data }) {
          dispatch("fetchCart");
          dispatch("getRestaurantsList");
          commit("SET_RESTAURANT_DETAILS", data.data);
          resolve(data);
        })
        .catch((err) => {
          commit("SET_TOKEN", "");
          $nuxt.$ls.set("store-token", "");
          $nuxt._router.push({
            name: "order"
          });
          reject(err);
        })
        .finally(() => {
          commit("SET_INFO_LOADING", false);
        });
    });
  },
  getAddresses({ dispatch, commit }, payload) {
    return new Promise((resolve, reject) => {
      this.$axios
        .get(getStoreApiUrl("customer/address"))
        .then(async function ({ data }) {
          commit("SET_ADDRESSES", data);
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  addAddress({ dispatch, commit }, payload) {
    return new Promise((resolve, reject) => {
      this.$axios
        .post(getStoreApiUrl("customer/address"), payload)
        .then(async function ({ data }) {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateAddress({ dispatch, commit }, { id, ...payload }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .patch(getStoreApiUrl(`customer/address/${id}`), { address: payload })
        .then(async function ({ data }) {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  validateCartAddress({ state }) {
    const deliveryAddress = state.cart?.delivery_address;

    if (!deliveryAddress.house_number) {
      $nuxt.$router.push("/order/address/new");
    } else {
      $nuxt.$router.push("/order/menu");
    }
  },
  fetchCart({ dispatch, state, commit }) {
    const restaurantId = $nuxt.$ls.get("selected-restaurant");
    commit("SET_CART_LOADING", true);
    return new Promise((resolve, reject) => {
      this.$axios
        .get(getStoreApiUrl("/cart/current"), {
          params: {
            restaurantId
          }
        })
        .then(function (response) {
          commit("SET_CART", response.data);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          commit("SET_CART_LOADING", false);
        });
    });
  },
  async syncCart({ dispatch, state, commit }) {
    if (!state.cart.id) {
      await dispatch("fetchCart");
    }
    clearTimeout(cartSyncTimout);
    isPendingCartSyncTimeout = true;
    cartSyncTimout = setTimeout(() => {
      isPendingCartSyncTimeout = false;
      commit("SET_CART_SYNCING", true);
      this.$axios
        .patch(getStoreApiUrl(`cart/${state.cart.id}`), state.cart)
        .then(function (response) {
          if (!isPendingCartSyncTimeout) {
            commit("SET_CART", response.data);
          }
          resolve(response);
        })
        .catch((err) => {
          this.$nuxt.$emit("show-error-toast", err);
          reject(err);
        })
        .finally(() => {
          commit("SET_CART_SYNCING", false);
        });
    }, 500);
  },
  updateCart(
    { dispatch, state, commit, getters },
    { menuItems, address, customer_notes }
  ) {
    if (menuItems) {
      // let items = cloneDeep(state?.cart?.items) || [];
      let items = JSON.parse(JSON.stringify(state.cart?.items || []));
      menuItems.forEach((menuItem) => {
        // menuItem = cloneDeep(menuItem);
        const index = getters.getCartItemIndex(menuItem);
        if (index < 0) {
          items.push(menuItem);
        } else {
          if (menuItem.quantity === 0) {
            items.splice(index, 1);
          } else {
            items[index] = menuItem;
          }
        }
        commit("SET_CART_ITEMS", items);
      });
    }
    if (address) {
      $nuxt.$ls.set("delivery-address", address);
      commit("SET_CART", {
        ...state.cart,
        delivery_address: address
      });
    }
    commit("SET_CART", {
      ...state.cart,
      delivery_address: address || state.cart.delivery_address,
      customer_notes:
        customer_notes !== undefined
          ? customer_notes
          : state.cart.customer_notes
    });

    dispatch("syncCart");
  },
  validateCart({ state, commit }, { isSilent = false } = {}) {
    if (!isSilent) {
      commit("SET_CART_LOADING", true);
    }
    return new Promise((resolve, reject) => {
      this.$axios
        .patch(getStoreApiUrl(`cart/${state.cart.id}/validate`))
        .then(function (response) {
          commit("SET_CART", response.data);
          resolve(response);
        })
        .catch((err) => {
          const cart = err?.response?.data?.cart;
          if (cart) {
            commit("SET_CART", { ...state.cart, items: cart.items });
          }
          $nuxt.$store.dispatch("menu/getMenuListForOrder", {
            forceFetch: true
          });
          reject(err);
        })
        .finally(() => {
          commit("SET_CART_LOADING", false);
        });
    });
  },
  replaceCartItem(
    { dispatch, state, commit, getters },
    { existingCartItem, newCartItem }
  ) {
    let items = cloneDeep(state.cart.items);
    newCartItem = cloneDeep(newCartItem);
    const existingIndex = getters.getCartItemIndex(existingCartItem);
    if (existingIndex >= 0) {
      items.splice(existingIndex, 1);
    }
    const mergeIndex = items.findIndex((item) =>
      isItemsMatch(item, newCartItem)
    );
    if (mergeIndex >= 0) {
      items[mergeIndex].quantity += newCartItem.quantity;
    } else {
      items.push(newCartItem);
    }
    commit("SET_CART_ITEMS", items);
    dispatch("syncCart");
  },
  addOrMergeCartItem({ dispatch, state, commit, getters }, newCartItem) {
    let items = cloneDeep(state?.cart?.items) || [];
    newCartItem = cloneDeep(newCartItem);
    const index = getters.getCartItemIndex(newCartItem);
    if (index < 0) {
      items.push(newCartItem);
    } else {
      items[index].quantity += newCartItem.quantity;
    }
    commit("SET_CART_ITEMS", items);
    dispatch("syncCart");
  },
  checkoutCart({ state }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .get(getStoreApiUrl(`cart/${state.cart.id}/checkout`))
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  initiatePayment({ state }, { orderId } = {}) {
    return new Promise((resolve, reject) => {
      this.$axios
        .get(getStoreApiUrl(`payments/initiate/${orderId}`))
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
};
export const getters = {
  hasMultipleRestaurants(state) {
    return state.restaurantsList.length > 1;
  },
  isDeliveryAddressSelected(state) {
    return (
      !!state.cart.delivery_address?.id || !!$nuxt.$ls.get("delivery-address")
    );
  },
  isRestaurantSelected(state) {
    return !!state.cart.restaurant_id || !!$nuxt.$ls.get("selected-restaurant");
  },
  getCartItemList(state) {
    return (menuItem) => {
      return (
        state.cart?.items?.filter((item) => {
          return isItemsMatch(item, menuItem);
        }) || []
      );
    };
  },
  getCartItemIndex(state) {
    return (menuItem) => {
      return state.cart?.items?.findIndex((item) => {
        return isItemsMatch(item, menuItem);
      });
    };
  },
  getUnavailableItems(state) {
    return state.cart?.items?.filter((item) => !!item.error);
  },
  getRestaurantsListDistance(state) {
    return state.restaurantsList.map((restaurant) => {
      const [restaurant_id, distance, porter_delivery_price] =
        state.restaurantsListByAvailability.find(
          (el) => el[0] === restaurant.restaurant_id
        ) || [];
      return {
        ...restaurant,
        distance,
        porter_delivery_price
      };
    });
  },
  isHomeDelivery(state) {
    return state.cart.order_type === HOME_DELIVERY.id;
  },
  isIncompleteDeliveryAddressInCart(state) {
    return (
      state.cart.order_type === HOME_DELIVERY.id &&
      !state.cart.delivery_address?.id &&
      !state.cart?.delivery_address?.house_number
    );
  }
};
